module.exports = __webpack_public_path__ + "static/img/int9.54f8ee3e.jpg";